import React from 'react'
import ToppingInfoButton from '../ToppingInfo'
import { ProductQuantity, Topping, ToppingContent, ToppingMinus, ToppingName, ToppingPrice, ToppingTotal } from '../index.styled'
import ToppingBackButton from '../ToppingBack'
import Currency from '../../../../../currency'

const StandardContent = React.memo(({
	layout,
	subItem,
	subItemIndex,
	isCanceledSubItem,
	isPreparedToCancel,
	isCanceledItem,
	disabled,
	onClickToppingInfo,
	onClickToppingMinus,
	onClickBackTopping,
	infoAvailable
}) => {
	const cancelLayout =  (!isCanceledItem && (isCanceledSubItem || isPreparedToCancel ) ? ' strikethrough' : '')

	const layoutTopping = layout + (subItem.quantity < 0 ? ' minus' : '') +
		((isPreparedToCancel && !isCanceledItem) ? ' noRoundCorner' : '') +
		(isCanceledSubItem ? ' noRoundCornerLeft' : '')
	return (
		<>
			<Topping className={layoutTopping}
							 data-testid={subItem.name}>
				{(isCanceledSubItem || isPreparedToCancel) && !isCanceledItem  && infoAvailable ?
					<ToppingInfoButton
						layout={layout}
						subItem={subItem}
						subItemIndex={subItemIndex}
						onClickToppingInfo={onClickToppingInfo}
					/> :
					<>
						{subItem.quantity > 0 ?
							<svg xmlns="http://www.w3.org/2000/svg" width="11.625" height="11.625" viewBox="0 0 11.625 11.625">
								<path d="M324.433,202.056l4.309-.018a0.754,0.754,0,0,0,.752-0.752,0.743,0.743,0,0,0-.747-0.748l-4.31.019,0.019-4.31a0.746,0.746,0,0,0-.748-0.748,0.756,0.756,0,0,0-.752.753l-0.019,4.309-4.309.019a0.754,0.754,0,0,0-.752.752,0.741,0.741,0,0,0,.747.747l4.31-.018-0.019,4.309a0.744,0.744,0,0,0,.748.748,0.754,0.754,0,0,0,.752-0.752Z" transform="translate(-317.875 -195.5)"></path>
							</svg> :
							<svg width="11" height="1" viewBox="0 0 11 1" xmlns="http://www.w3.org/2000/svg">
								<rect width="11" height="1" rx="0.5" />
							</svg>
						}
					</>
				}
				<ToppingContent className={cancelLayout}>
					<ToppingName className={layout + (subItem.quantity < 0 ? ' minus' : '')}>
						{subItem.name}
						{(subItem?.quantity > 1 || subItem?.quantity < -1) &&
							<ProductQuantity className={layout}> x {Math.abs(subItem.quantity)}</ProductQuantity>}
					</ToppingName>

					{!disabled && <ToppingPrice className={layout}><Currency>{subItem.price}</Currency></ToppingPrice>}
					<ToppingTotal className={layout} />
				</ToppingContent>
				{(!disabled && !['CANCELED', 'PREPARED_TO_CANCEL'].includes(subItem.status) && !isCanceledItem) &&
					<ToppingMinus
						className={layout + (subItem.quantity < 0 ? ' minus' : '')}
						onClick={event => onClickToppingMinus(event, subItemIndex)}
						data-testid="btn-remove-topping">
						<svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="22" height="4" viewBox="0 0 10.781 1.844">
							<path d="M486.363,202.33h-8.948a0.915,0.915,0,1,1,0-1.83h8.948A0.915,0.915,0,1,1,486.363,202.33Z" transform="translate(-476.5 -200.5)" />
						</svg>
					</ToppingMinus>
				}
				{isPreparedToCancel && !isCanceledItem &&
					<ToppingBackButton
						layout={layout}
						subItem={subItem}
						subItemIndex={subItemIndex}
						onClickBackTopping={onClickBackTopping}
					/>
				}
			</Topping>
		</>
	)
})
export default StandardContent
StandardContent.displayName = 'StandardContent'
